/**
 * @file:  待办事项日历
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/9/6      1.0     First version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent} from "react";
import {Spin,Calendar,Badge,Pagination} from 'antd';
import dayjs from 'dayjs';
import FollowBtn from "@components/FollowUp/FollowBtn";
import {isEmpty,getIntlYYMMDD} from "@utils/utils";
import Lang from "@/components/Lang/Lang";
import {NewBuyerLabel, TransactionCustomerStage,InternalBuyerLabel} from "@components/StatuLabel/statuBuyerLabel";// dop-webapp/src/components/StatuLabel/statuBuyerLabel.js
import DopIndexAction from "../../dopIndex.action";
// import "./index.less";

export default class CalendarFollowUpMatters extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            pagingQuery: {
                pageSize: 8,
                total: 0,
                pageIndex: 1
            },
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /**
     * 跟进统计(日历图)
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8311
     */
    fetchMonthRedDot(searchObjMonth={}){
        this.loading(true);
        // 小红点要前后多查一周
        DopIndexAction.postHttpAction("/service/mg/home/follow/statistics",searchObjMonth).then((resp)=>this.handleRedRes(resp.data,searchObjMonth )).catch(err=>this.handleRedRes(err));
    }
    handleRedRes(res={},searchObjMonth){
        this.loading(false)
        const {success,valid,models=[],model }= res;
        if(success&&valid){
            this.setState({
                redDotList: models,
                redNum:model||0,
                searchObjMonth:searchObjMonth
            })
        }
    }
    fetchToDoList(searchObj={},pageIndex=1){
        this.loading(true);
        const { pagingQuery:{pageSize}}=this.state;
        const pagingQueryObj = {
            pageIndex: pageIndex,
            pageSize: pageSize,
        }
        const obj = {...searchObj,  pagingQuery: pagingQueryObj}
        DopIndexAction.postHttpAction("/service/mg/home/follow/list",obj).then((resp)=>this.handleRes(resp.data,searchObj,pagingQueryObj)).catch(err=>this.handleRes(err));
    }
    handleRes(res={},searchObj={},pagingQuery={}){
        const {success,valid,models=[],paging={} }= res;
        if(success&&valid){
            $(document).scrollTop(0);
            this.setState({
                toDoList: models,
                searchObj:searchObj,
                pagingQuery:{
                    ...pagingQuery,
                    total:paging.total||0
                }
            })
        }
        this.loading(false)
    }
    // 时间
    onPanelChange = (value, mode) => {
        this.onChangeMonth(value)
    }
    // 查询 月日历面板
    onChangeMonth(value){
        this.fetchMonthRedDot({
            startTime:  dayjs(value).startOf('month').subtract(14, 'days').valueOf(),// 开始 时间
            endTime:dayjs(value).endOf('month').add(14, 'days').valueOf(),//  结束时间
        });
    }
    /*
    * 点击天
    * */
    onChangeCalendar(date){
        this.fetchToDoList({
            startTime:dayjs(date).startOf('days').valueOf(),
            endTime: dayjs(date).endOf('days').valueOf(),
        });
    }
    dateCellRender(date,redDotList=[]){
        const current = date.format('YYYY-MM-DD');
        const flag = redDotList.indexOf(current) !== -1;
        return <Badge color={flag?"#FB7321":"#Fff"}/>
    }
    // 操作回调刷新页面
    refreshPage(){
        const {searchObjMonth={},searchObj={}} = this.state;
        // 当前搜索过的内容 刷新
        this.fetchMonthRedDot(searchObjMonth);
        this.fetchToDoList(searchObj);
    }
    onChangePage(current){
        const { searchObj} = this.state;
        this.fetchToDoList(searchObj,current);
    }
    getLabelType(labelType){
        let key = "1020";
        //new : 新客 deal:已成交 internal:潜在客户
        switch (labelType) {
            case "new":
                key = '1010';
                break;
            case "deal":
                key = '1020';
                break;
            case "internal":
                key = '1030';
                break;
        }
        return key;
    }
    componentWillMount() {
        // 默认本月
        this.onChangeMonth();
        // 默认本日
        this.fetchToDoList({
            startTime:dayjs().startOf('days').valueOf(),
            endTime: dayjs().endOf('days').valueOf(),
        });
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }

    render() {
        const {loading = true,toDoList=[], redDotList=[],redNum,searchObj={},pagingQuery} = this.state;
        return (<Spin spinning={loading}>
            <div className={"font_18 fw_500 mb_16 lineH_27 flex-item-ver-center"}>{Lang({ id: "DaiGenJinShiXiang", default:'待跟进事项' })}
                <Badge count={redNum} offset={[4, 0]} />
            </div>
            <Calendar fullscreen={false}
                      onPanelChange={(date,mode)=>this.onPanelChange(date,mode)}
                      onChange={(date)=>this.onChangeCalendar(date)}
                      headerRender={({ value, type, onChange, onTypeChange }) => {
                          const year = value.year();
                          const month2 = value.format('MMMM');
                          return (<div className={"font_16 fw_700 flex-item-between pb_4"} style={{width:"60%",margin:"0 auto"}}>
                              <i className="ri-arrow-left-s-line cursor-p" onClick={()=>onChange(dayjs(value).subtract(1, 'months'))}></i>
                              <div className={"flex-1 text-center"}>
                                  {month2}
                                  <span className={"ml_8"}>{year}</span>
                              </div>
                              <i className="ri-arrow-right-s-line cursor-p" onClick={()=>onChange(dayjs(value).add(1, 'months'))}></i>
                          </div>)
                      }}
                      cellRender={(date)=>this.dateCellRender(date,redDotList)}
            />
            {toDoList.map((item,inx)=>{
                const labelType = this.getLabelType(item.labelType);
                const sCountryUrl =item.abbreviate?require('../../../../assets/img/country/'+item.abbreviate + '.png'):"";
                return(<FollowBtn labelType={labelType}////	1010:新客标签 1020:成交客户标签 1030潜在采购商
                                  buyerId={item.buyerId}
                                  buyerInternalId={item.buyerId}
                                  refreshPage={()=>this.refreshPage(searchObj)}>
                        <div className={"commonBox whiteBox mt_16"} key={"do_s_"+inx}>
                        <div className={"flex-item-between"}>
                            <div>
                                <div className={"font_16 fw_700 lineH_150p"}>
                                    {item.abbreviate?<img className="mr_4" src={sCountryUrl.default} width={24} />:null}
                                    {item.buyerCode||"-"}</div>
                                <div className={"font_12 black45 lineH_150p"}>{item.buyerName||"-"}</div>
                            </div>
                            {/*   labelType   new :  新客标签   deal:成交客户标签  internal:潜在采购商*/}

                            {item.labelType=="new"?
                                <NewBuyerLabel statusCode={item.labelCode} status={item.labelName} />
                                :
                                null
                            }
                            {item.labelType=="deal"?
                                <TransactionCustomerStage statusCode={item.labelCode} status={item.labelName} />
                                :
                                null
                            }
                            {item.labelType=="internal"?
                                <InternalBuyerLabel statusCode={item.labelCode} status={item.labelName} />
                                :
                                null
                            }
                        </div>
                        <div className={"mt_8 lineH_150p"}>{item.nextFollowRemark||Lang({ id: "ZanWuGenJinNeiRongBeiWang", default:'暂无跟进内容备忘' })}
                        </div>
                        <div className={"mt_8 fw_500 lineH_150p"}>
                            {item.expiredDays===0?<span className={"color_FB7321"}>{Lang({ id: "JinTian", default:'今天' })}</span>:null}
                            {item.expiredDays>0?<span className={"color-red2"}>{Lang({ id: "NYiGuoQiNTian", default:`${getIntlYYMMDD(item.nextFollowTime)} 已过期 ${item.expiredDays} 天`,params:[getIntlYYMMDD(item.nextFollowTime),item.expiredDays] })}</span>:null}
                            {item.expiredDays===-1?<span className={"color-blue3"}>{Lang({ id: "MingTian", default:`明天` })}</span>:null}
                            {item.expiredDays<-1?<span className={"color-blue3"}>{getIntlYYMMDD(item.nextFollowTime)}</span>:null}
                            </div>
                    </div>
                </FollowBtn>)
            }) }
            <Pagination className={"mt_12"}
                        total={pagingQuery.total}
                        defaultPageSize={pagingQuery.pageSize}
                        current={pagingQuery.pageIndex}
                        showSizeChanger={false}
                        onChange={this.onChangePage.bind(this)} />
        </Spin>);
    }
}
